// extracted by mini-css-extract-plugin
export default {"botoes":"VersoesIndex_botoes__AOzXA","barra":"VersoesIndex_barra__SNAO6","td":"VersoesIndex_td__pS4u3"};